import React, { useEffect, useRef, useState } from 'react';
import gsap from 'gsap';
import bgImage from '../../Images/Emaar/emaarherosection.png';

// ── API ────────────────────────────────────────────────────────
const API_URL =
  "https://homewalkers.realatixcrm.com/api/v1/users/create-with-params" +
  "?addedby=68da45a5b37ddfab3b73bd8b" +
  "&stage=68d110bbad5a0732ad44e5cf" +
  "&Channal=6a48bfa6a4cf5854ad69d511" +
  "&project=6a424455cbc3b90bfa64cd4b" +
  "&salesdata=68da75b5b37ddfab3b7463f5" +
  "&Communicationway=69159308820816f4ad71c3bf" +
  "&campaignid=68e3a33dbd4758877fb945a1" +
  "&includePhone2=false" +
  "&includeWhatsapp=false" +
  "&includeJobDesc=false" +
  "&includeQuestion1=true" +
  "&question1_text=%D8%A7%D9%84%D8%BA%D8%B1%D8%B6++%D9%85%D9%86+%D8%A7%D9%84%D8%B4%D8%B1%D8%A7%D8%A1+%D8%9F" +
  "&includeQuestion2=true" +
  "&question2_text=%D8%B9%D8%AF%D8%AF+%D8%A7%D9%84%D8%BA%D8%B1%D9%81+%D8%9F" +
  "&includeQuestion3=false" +
  "&includeQuestion4=false" +
  "&includeQuestion5=false";

// ── خيارات الفورم ──────────────────────────────────────────────
const purposeOptions = ['السكن', 'الاستثمار', 'سكن واستثمار'];
const roomOptions    = ['استوديو', '1 غرفة', '2 غرفة', '3 غرفة'];

// ── أكواد الدول (iso2 + dial code) ──────────────────────────────
const countryCodes = [
  { iso: 'ae', name: 'الإمارات',        dial: '+971' },
  { iso: 'sa', name: 'السعودية',        dial: '+966' },
  { iso: 'eg', name: 'مصر',             dial: '+20'  },
  { iso: 'kw', name: 'الكويت',          dial: '+965' },
  { iso: 'qa', name: 'قطر',             dial: '+974' },
  { iso: 'bh', name: 'البحرين',         dial: '+973' },
  { iso: 'om', name: 'عُمان',           dial: '+968' },
  { iso: 'jo', name: 'الأردن',          dial: '+962' },
  { iso: 'lb', name: 'لبنان',           dial: '+961' },
  { iso: 'iq', name: 'العراق',          dial: '+964' },
  { iso: 'sy', name: 'سوريا',           dial: '+963' },
  { iso: 'ye', name: 'اليمن',           dial: '+967' },
  { iso: 'ps', name: 'فلسطين',          dial: '+970' },
  { iso: 'ma', name: 'المغرب',          dial: '+212' },
  { iso: 'dz', name: 'الجزائر',         dial: '+213' },
  { iso: 'tn', name: 'تونس',            dial: '+216' },
  { iso: 'ly', name: 'ليبيا',           dial: '+218' },
  { iso: 'sd', name: 'السودان',         dial: '+249' },
  { iso: 'so', name: 'الصومال',         dial: '+252' },
  { iso: 'dj', name: 'جيبوتي',          dial: '+253' },
  { iso: 'km', name: 'جزر القمر',       dial: '+269' },
  { iso: 'mr', name: 'موريتانيا',       dial: '+222' },
  { iso: 'tr', name: 'تركيا',           dial: '+90'  },
  { iso: 'ir', name: 'إيران',           dial: '+98'  },
  { iso: 'pk', name: 'باكستان',         dial: '+92'  },
  { iso: 'in', name: 'الهند',           dial: '+91'  },
  { iso: 'bd', name: 'بنغلاديش',        dial: '+880' },
  { iso: 'lk', name: 'سريلانكا',        dial: '+94'  },
  { iso: 'np', name: 'نيبال',           dial: '+977' },
  { iso: 'ph', name: 'الفلبين',         dial: '+63'  },
  { iso: 'id', name: 'إندونيسيا',       dial: '+62'  },
  { iso: 'my', name: 'ماليزيا',         dial: '+60'  },
  { iso: 'cn', name: 'الصين',           dial: '+86'  },
  { iso: 'us', name: 'الولايات المتحدة', dial: '+1'   },
  { iso: 'gb', name: 'المملكة المتحدة', dial: '+44'  },
  { iso: 'fr', name: 'فرنسا',           dial: '+33'  },
  { iso: 'de', name: 'ألمانيا',         dial: '+49'  },
  { iso: 'it', name: 'إيطاليا',         dial: '+39'  },
  { iso: 'es', name: 'إسبانيا',         dial: '+34'  },
  { iso: 'ru', name: 'روسيا',           dial: '+7'   },
  { iso: 'ca', name: 'كندا',            dial: '+1'   },
  { iso: 'au', name: 'أستراليا',        dial: '+61'  },
  { iso: 'za', name: 'جنوب أفريقيا',    dial: '+27'  },
  { iso: 'ng', name: 'نيجيريا',         dial: '+234' },
  { iso: 'ke', name: 'كينيا',           dial: '+254' },
  { iso: 'et', name: 'إثيوبيا',         dial: '+251' },
  { iso: 'br', name: 'البرازيل',        dial: '+55'  },
  { iso: 'jp', name: 'اليابان',         dial: '+81'  },
  { iso: 'kr', name: 'كوريا الجنوبية',  dial: '+82'  },
];

// ── Field style ────────────────────────────────────────────────
const inputStyle = {
  width:        '100%',
  padding:      '13px 16px',
  border:       '1.5px solid #e0d8cc',
  borderRadius: '10px',
  fontSize:     '14px',
  fontFamily:   "'Cairo', sans-serif",
  color:        '#1a1a1a',
  background:   '#fff',
  outline:      'none',
  boxSizing:    'border-box',
  direction:    'rtl',
  transition:   'border-color 0.2s ease, box-shadow 0.2s ease',
};

const labelStyle = {
  fontSize:     '13px',
  fontWeight:   '600',
  color:        '#444',
  display:      'block',
  marginBottom: '7px',
  direction:    'rtl',
};

export const EmaarContactForm = () => {
  const sectionRef = useRef(null);
  const formRef    = useRef(null);
  const rightRef   = useRef(null);

  const [formData, setFormData] = useState({
    name:              '',
    phone:             '',
    email:             '',
    question1_answer:  'السكن',
    question2_answer:  '',
  });
  const [countryIso, setCountryIso] = useState('ae');
  const [loading, setLoading] = useState(false);
  const [alert,   setAlert]   = useState({ show: false, message: '', ok: false });

  const selectedCountry = countryCodes.find((c) => c.iso === countryIso) || countryCodes[0];

  // ── Animations ─────────────────────────────────────────────
  useEffect(() => {
    const section = sectionRef.current;
    const form    = formRef.current;
    const right   = rightRef.current;
    if (!section) return;

    gsap.set(form,  { opacity: 0, x: -40 });
    gsap.set(right, { opacity: 0, x:  40 });

    const obs = new IntersectionObserver((entries) => {
      entries.forEach((e) => {
        if (e.isIntersecting) {
          gsap.to(form,  { opacity: 1, x: 0, duration: 0.9, ease: 'power3.out' });
          gsap.to(right, { opacity: 1, x: 0, duration: 0.9, ease: 'power3.out', delay: 0.15 });
        } else {
          gsap.set(form,  { opacity: 0, x: -40 });
          gsap.set(right, { opacity: 0, x:  40 });
        }
      });
    }, { threshold: 0.1 });

    obs.observe(section);
    return () => obs.disconnect();
  }, []);

  // ── Alert auto-hide ────────────────────────────────────────
  useEffect(() => {
    if (!alert.show) return;
    const t = setTimeout(() => setAlert((p) => ({ ...p, show: false })), 5000);
    return () => clearTimeout(t);
  }, [alert.show]);

  // ── Handlers ───────────────────────────────────────────────
  const handleChange = (field) => (e) =>
    setFormData((p) => ({ ...p, [field]: e.target.value }));

  const handleFocus = (e) => {
    e.target.style.borderColor = '#c8a04a';
    e.target.style.boxShadow   = '0 0 0 3px rgba(200,160,74,0.12)';
  };
  const handleBlur = (e) => {
    e.target.style.borderColor = '#e0d8cc';
    e.target.style.boxShadow   = 'none';
  };

  // ── Submit ─────────────────────────────────────────────────
  const handleSubmit = async (e) => {
    e.preventDefault();

    // ✅ Validate الهاتف فقط
    const phone = formData.phone.trim();
    if (!phone || phone.replace(/\D/g, '').length < 6)
      return setAlert({ show: true, message: 'يرجى إدخال رقم هاتف صحيح', ok: false });

    const fullPhone = `${selectedCountry.dial}${phone.replace(/\D/g, '')}`;

    setLoading(true);
    setAlert({ show: false, message: '', ok: false });

    try {
      const res = await fetch(API_URL, {
        method:  'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          name:             formData.name.trim() || 'no name',
          email:            formData.email.trim().toLowerCase() || '',
          phone:            fullPhone,
          question1_answer: formData.question1_answer,
          question2_answer: formData.question2_answer,
        }),
      });

      if (!res.ok) throw new Error(`${res.status}`);

      setAlert({ show: true, message: 'تم الإرسال بنجاح ✅', ok: true });
      setFormData({ name: '', phone: '', email: '', question1_answer: 'السكن', question2_answer: '' });

    } catch (err) {
      const status = err.message;
      setAlert({
        show: true,
        ok:   false,
        message:
          status.includes('409') ? 'رقم الهاتف مسجّل مسبقاً'
        : status.includes('400') ? 'بيانات غير صحيحة، يرجى المراجعة'
        : 'حدث خطأ، يرجى المحاولة مجدداً',
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <section
      ref={sectionRef}
      style={{
        display:   'flex',
        minHeight: '100vh',
        fontFamily:"'Cairo', sans-serif",
        direction: 'rtl',
        overflow:  'hidden',
      }}
    >
      {/* ══════════════════════════════════════════
          يسار — الفورم
      ══════════════════════════════════════════ */}
      <div
        ref={formRef}
        style={{
          width:          '100%',
          maxWidth:       '480px',
          minWidth:       '320px',
          background:     '#fff',
          padding:        'clamp(32px, 5vw, 56px) clamp(24px, 4vw, 48px)',
          display:        'flex',
          flexDirection:  'column',
          justifyContent: 'center',
          opacity:        0,
          flexShrink:     0,
          boxShadow:      '4px 0 32px rgba(0,0,0,0.08)',
          position:       'relative',
          zIndex:         2,
        }}
      >
        {/* Header */}
        <div style={{ marginBottom: '28px' }}>
          <p style={{
            fontSize:      '11px',
            fontWeight:    '700',
            color:         '#c8a04a',
            letterSpacing: '3px',
            textTransform: 'uppercase',
            margin:        '0 0 10px 0',
          }}>
            EMAAR GOLF FIELD
          </p>
          <h2 style={{
            fontSize:   'clamp(22px, 3vw, 30px)',
            fontWeight: '900',
            color:      '#1a1a1a',
            margin:     '0 0 8px 0',
            lineHeight: '1.2',
          }}>
            لمزيد من التفاصيل
          </h2>
          <p style={{ fontSize: '14px', color: '#888', margin: '0 0 4px 0' }}>
            سجل بياناتك وسنتواصل معك في أقرب وقت
          </p>
          <div style={{
            width:        '48px',
            height:       '3px',
            background:   'linear-gradient(to left, #c8a04a, #f0d080)',
            borderRadius: '2px',
            marginTop:    '14px',
          }} />
        </div>

        {/* Alert */}
        {alert.show && (
          <div style={{
            background:   alert.ok ? 'rgba(74,124,63,0.08)' : 'rgba(200,50,50,0.07)',
            border:       `1px solid ${alert.ok ? 'rgba(74,124,63,0.3)' : 'rgba(200,50,50,0.25)'}`,
            borderRadius: '10px',
            padding:      '11px 16px',
            marginBottom: '18px',
            fontSize:     '14px',
            fontWeight:   '600',
            color:        alert.ok ? '#2e5e26' : '#9b2020',
            display:      'flex',
            justifyContent: 'space-between',
            alignItems:   'center',
          }}>
            <span>{alert.message}</span>
            <button
              onClick={() => setAlert((p) => ({ ...p, show: false }))}
              style={{ background: 'none', border: 'none', cursor: 'pointer',
                color: 'inherit', fontSize: '16px', lineHeight: 1, padding: '0 0 0 8px' }}
            >✕</button>
          </div>
        )}

        {/* Form */}
        <form onSubmit={handleSubmit} noValidate style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>

          {/* الاسم */}
          <div>
            <label style={labelStyle}>الاسم</label>
            <input
              type="text"
              placeholder="الاسم"
              value={formData.name}
              onChange={handleChange('name')}
              onFocus={handleFocus}
              onBlur={handleBlur}
              style={inputStyle}
            />
          </div>

          {/* رقم الهاتف */}
          <div>
            <label style={{ ...labelStyle }}>
              رقم الهاتف <span style={{ color: '#c8a04a' }}>*</span>
            </label>
            <div style={{ display: 'flex', gap: '8px', direction: 'ltr' }}>

              {/* Select كود الدولة */}
              <div style={{ position: 'relative', flexShrink: 0, width: '128px' }}>
                <img
                  src={`https://flagcdn.com/w20/${selectedCountry.iso}.png`}
                  alt={selectedCountry.iso}
                  style={{
                    position:  'absolute',
                    left:      '10px',
                    top:       '50%',
                    transform: 'translateY(-50%)',
                    width:     '20px',
                    borderRadius: '2px',
                    pointerEvents: 'none',
                    zIndex: 1,
                  }}
                />
                <select
                  value={countryIso}
                  onChange={(e) => setCountryIso(e.target.value)}
                  onFocus={handleFocus}
                  onBlur={handleBlur}
                  style={{
                    ...inputStyle,
                    direction:        'ltr',
                    paddingLeft:      '38px',
                    paddingRight:     '26px',
                    appearance:       'none',
                    WebkitAppearance: 'none',
                    backgroundImage:  `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 24 24' fill='none' stroke='%23c8a04a' stroke-width='2'%3E%3Cpolyline points='6 9 12 15 18 9'/%3E%3C/svg%3E")`,
                    backgroundRepeat:   'no-repeat',
                    backgroundPosition: 'right 10px center',
                    cursor:             'pointer',
                    fontWeight:         '600',
                    fontSize:           '13px',
                  }}
                >
                  {countryCodes.map((c) => (
                    <option key={c.iso} value={c.iso}>
                      {c.dial} {c.name}
                    </option>
                  ))}
                </select>
              </div>

              {/* رقم الهاتف */}
              <input
                type="tel"
                placeholder="رقم الهاتف"
                value={formData.phone}
                onChange={handleChange('phone')}
                onFocus={handleFocus}
                onBlur={handleBlur}
                style={{ ...inputStyle, direction: 'ltr', textAlign: 'right', flex: 1 }}
              />
            </div>
          </div>

          {/* الإيميل */}
          <div>
            <label style={labelStyle}>الإيميل</label>
            <input
              type="email"
              placeholder="الإيميل"
              value={formData.email}
              onChange={handleChange('email')}
              onFocus={handleFocus}
              onBlur={handleBlur}
              style={{ ...inputStyle, direction: 'ltr', textAlign: 'right' }}
            />
          </div>

          {/* الغرض من الشراء */}
          <div>
            <label style={labelStyle}>الغرض من الشراء</label>
            <select
              value={formData.question1_answer}
              onChange={handleChange('question1_answer')}
              onFocus={handleFocus}
              onBlur={handleBlur}
              style={{
                ...inputStyle,
                appearance:      'none',
                WebkitAppearance:'none',
                backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 24 24' fill='none' stroke='%23c8a04a' stroke-width='2'%3E%3Cpolyline points='6 9 12 15 18 9'/%3E%3C/svg%3E")`,
                backgroundRepeat:   'no-repeat',
                backgroundPosition: 'left 14px center',
                paddingLeft:        '36px',
                cursor:             'pointer',
              }}
            >
              {purposeOptions.map((o) => (
                <option key={o} value={o}>{o}</option>
              ))}
            </select>
          </div>

          {/* عدد الغرف */}
          <div>
            <label style={labelStyle}>عدد الغرف</label>
            <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
              {roomOptions.map((room) => (
                <label
                  key={room}
                  style={{
                    display:      'flex',
                    alignItems:   'center',
                    gap:          '6px',
                    cursor:       'pointer',
                    fontSize:     '13px',
                    fontWeight:   '600',
                    color:        formData.question2_answer === room ? '#c8a04a' : '#555',
                    padding:      '7px 14px',
                    borderRadius: '8px',
                    border:       `1.5px solid ${formData.question2_answer === room ? '#c8a04a' : '#e0d8cc'}`,
                    background:   formData.question2_answer === room ? 'rgba(200,160,74,0.08)' : '#fff',
                    transition:   'all 0.2s ease',
                  }}
                >
                  <input
                    type="radio"
                    name="rooms"
                    value={room}
                    checked={formData.question2_answer === room}
                    onChange={handleChange('question2_answer')}
                    style={{ display: 'none' }}
                  />
                  {room}
                </label>
              ))}
            </div>
          </div>

          {/* زرار الإرسال */}
          <button
            type="submit"
            disabled={loading}
            style={{
              width:        '100%',
              padding:      '15px',
              marginTop:    '6px',
              background:   loading ? 'rgba(200,160,74,0.5)' : 'linear-gradient(135deg, #b8903a, #c8a04a, #e0b84a)',
              color:        '#fff',
              border:       'none',
              borderRadius: '12px',
              fontSize:     '16px',
              fontWeight:   '700',
              fontFamily:   "'Cairo', sans-serif",
              cursor:       loading ? 'not-allowed' : 'pointer',
              boxShadow:    '0 6px 20px rgba(200,160,74,0.35)',
              transition:   'all 0.25s ease',
              letterSpacing:'0.5px',
            }}
            onMouseEnter={(e) => { if (!loading) e.target.style.boxShadow = '0 10px 28px rgba(200,160,74,0.5)'; }}
            onMouseLeave={(e) => { e.target.style.boxShadow = '0 6px 20px rgba(200,160,74,0.35)'; }}
          >
            {loading ? 'جاري الإرسال...' : 'إرسال'}
          </button>
        </form>
      </div>

      {/* ══════════════════════════════════════════
          يمين — الصورة مع النص
      ══════════════════════════════════════════ */}
      <div
        ref={rightRef}
        style={{
          flex:     1,
          position: 'relative',
          overflow: 'hidden',
          minHeight:'500px',
          opacity:  0,
        }}
      >
        {/* الصورة */}
        <img
          src={bgImage}
          alt="Emaar Golf Field"
          style={{
            width:          '100%',
            height:         '100%',
            objectFit:      'cover',
            objectPosition: 'center',
            display:        'block',
          }}
        />

        {/* Overlay */}
        <div style={{
          position:   'absolute',
          inset:      0,
          background: 'linear-gradient(135deg, rgba(0,0,0,0.65) 0%, rgba(0,0,0,0.3) 60%, rgba(0,0,0,0.1) 100%)',
        }} />

        {/* النص */}
        <div style={{
          position:       'absolute',
          inset:          0,
          display:        'flex',
          flexDirection:  'column',
          justifyContent: 'center',
          alignItems:     'center',
          textAlign:      'center',
          padding:        '40px',
        }}>
          {/* Badge */}
          <div style={{
            background:     'rgba(200,160,74,0.2)',
            backdropFilter: 'blur(8px)',
            border:         '1px solid rgba(200,160,74,0.5)',
            color:          '#f0d080',
            fontSize:       '11px',
            fontWeight:     '700',
            letterSpacing:  '3px',
            padding:        '7px 20px',
            borderRadius:   '30px',
            marginBottom:   '24px',
            textTransform:  'uppercase',
          }}>
            EMAAR GOLF FIELD
          </div>

          <h2 style={{
            color:      '#fff',
            fontSize:   'clamp(28px, 4vw, 52px)',
            fontWeight: '900',
            lineHeight: '1.25',
            margin:     '0 0 16px 0',
            textShadow: '0 2px 24px rgba(0,0,0,0.5)',
          }}>
            دفعة أولى 20%<br />
            <span style={{ color: '#f0d080' }}>فقط</span>
          </h2>

          <p style={{
            color:      'rgba(255,255,255,0.85)',
            fontSize:   'clamp(15px, 2vw, 20px)',
            fontWeight: '400',
            margin:     '0 0 32px 0',
          }}>
            بادر بالحجز الآن
          </p>

          {/* Stats */}
          <div style={{
            display:   'flex',
            gap:       '24px',
            flexWrap:  'wrap',
            justifyContent: 'center',
          }}>
            {[
              { num: '1.26M', label: 'تبدأ من (درهم)' },
              { num: '2030',  label: 'موعد التسليم'   },
              { num: '3',     label: 'غرف كحد أقصى'  },
            ].map((s, i) => (
              <div key={i} style={{
                background:     'rgba(255,255,255,0.1)',
                backdropFilter: 'blur(8px)',
                border:         '1px solid rgba(255,255,255,0.2)',
                borderRadius:   '14px',
                padding:        '16px 24px',
                textAlign:      'center',
              }}>
                <p style={{ margin: 0, color: '#f0d080', fontSize: 'clamp(20px, 2.5vw, 28px)', fontWeight: '900' }}>
                  {s.num}
                </p>
                <p style={{ margin: '4px 0 0', color: 'rgba(255,255,255,0.75)', fontSize: '12px', fontWeight: '600' }}>
                  {s.label}
                </p>
              </div>
            ))}
          </div>

          {/* خط ذهبي */}
          <div style={{
            width:        '60px',
            height:       '3px',
            background:   'linear-gradient(to left, #c8a04a, #f0d080)',
            borderRadius: '2px',
            marginTop:    '32px',
          }} />
        </div>
      </div>

      {/* ── Responsive mobile ── */}
      <style>{`
        @media (max-width: 768px) {
          section[data-contact] {
            flex-direction: column !important;
          }
        }
      `}</style>
    </section>
  );
};
